import { Component, Input } from '@angular/core';

@Component({
  selector: 'tlp-loading-spinner',
  templateUrl: './loading-spinner.html',
  styleUrls: ['./loading-spinner.scss'],
  // host: {
  //   '[style.position]': '"fixed"',
  //   '[style.top]': '"0"',
  //   '[style.left]': '"0"',
  //   '[style.width]': '"100%"',
  //   '[style.height]': '"100%"',
  //   '[style.z-index]': '"10000"',
  //   '[style.pointer-events]': '"none"'
  // }
})
export class LoadingSpinnerComponent {}
